export const CHECKOUT_URL =
  'https://ophthalmology-visual-atlas.impultienda.ar/checkout'
export const PURCHASE_ANCHOR = '#comprar'

export const BOX_IMAGE =
  'https://cdn.magicpatterns.com/uploads/5uQ2UskY8zmvBGjrwA4Y14/Diseno-sin-titulo-6-2.webp'

export const insideImages: { src: string; caption: string }[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/jBWqEC5bbPGXUib59mJPeM/Captura_de_pantalla_2026-09-10_a_la(s)_8.43.27_p._m..png',
    caption: 'Decentration & Scan Position',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/jX7W1s8M6bb8LhPjhaqe6z/Captura_de_pantalla_2026-09-10_a_la(s)_8.43.46_p._m..png',
    caption: 'Multimodal Correlation',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/8nUxCSjmThZkWyVMC7PhFY/Captura_de_pantalla_2026-09-10_a_la(s)_8.44.08_p._m..png',
    caption: 'RNFL OCT Pattern Basics',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/xttDfcHQh28EZu23bWHLP8/Captura_de_pantalla_2026-09-10_a_la(s)_8.44.29_p._m..png',
    caption: 'Subretinal Fluid Pattern',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/gPby98QNd5q4furCXfvzk2/Captura_de_pantalla_2026-09-10_a_la(s)_8.44.54_p._m..png',
    caption: 'Retina–RPE–Choroid Interface',
  },
]

export const systemChecklist = [
  'OCT pattern references',
  'Fundus & retinal comparisons',
  'Optic nerve & RNFL visuals',
  'Visual field pattern maps',
  'Corneal imaging references',
  'Multimodal comparison tools',
  'Visual anatomy resources',
  'Professional references ready to use',
]

export interface Module {
  number: number
  title: string
  body: string
  steps: string
}

export const modules: Module[] = [
  {
    number: 1,
    title: 'OCT PATTERN ATLAS™',
    body: 'Review optical coherence tomography with organized visual references, annotated patterns, comparisons and anatomical correlations. Explore normal retinal anatomy, macular architecture, fluid patterns and structural changes clearly. Compare important OCT appearances without rebuilding your reference system every time. Use the atlas alongside appropriate clinical education and professional references.',
    steps: 'Observe. Compare. Recognize.',
  },
  {
    number: 2,
    title: 'FUNDUS & RETINAL PATTERN ATLAS™',
    body: 'Review retinal and posterior segment findings with structured visual references, comparisons and annotated examples. Explore fundus landmarks, retinal findings, vascular patterns, macular changes and posterior segment appearances. Use organized resources instead of searching for disconnected retinal images every day. Interpret them alongside appropriate clinical context and professional references.',
    steps: 'Locate. Compare. Recognize.',
  },
  {
    number: 3,
    title: 'OPTIC NERVE & GLAUCOMA VISUAL ATLAS™',
    body: 'Keep optic nerve, RNFL and glaucoma-related structural patterns organized in one clear system. Use visual references for disc anatomy, cupping, neuroretinal rim, RNFL and structural comparisons. Review relevant patterns without relying on scattered images or isolated references. Use appropriate clinical assessment and professional guidance as your reference.',
    steps: 'Inspect. Compare. Correlate.',
  },
  {
    number: 4,
    title: 'VISUAL FIELD PATTERN ATLAS™',
    body: 'Review visual field maps, common defect configurations and structure-function relationships. Keep field patterns, reliability information and visual comparisons together. Use structured references alongside appropriate clinical evaluation and testing information. Understand what matters without rebuilding your reference system every day.',
    steps: 'Map. Compare. Correlate.',
  },
  {
    number: 5,
    title: 'CORNEAL TOPOGRAPHY & ANTERIOR SEGMENT ATLAS™',
    body: 'Keep corneal imaging patterns and anterior segment visual references structured and easier to review. Use curvature, elevation, thickness maps and comparative corneal pattern references. Organize normal patterns, irregular configurations and important map relationships. Review what you see without searching for the same references from scratch.',
    steps: 'Map. Observe. Compare.',
  },
  {
    number: 6,
    title: 'OPHTHALMIC IMAGING INTEGRATION ATLAS™',
    body: 'Organize the information that needs to connect between different ophthalmic imaging modalities. Use structured fundus-OCT, disc-RNFL-field and corneal imaging comparison resources. Keep structural findings, functional patterns, correlations and important limitations clear. Build an organized overview of the complete ophthalmic visual pattern.',
    steps: 'Connect. Integrate. Recognize.',
  },
]

export interface Bonus {
  number: number
  title: string
  subtitle: string
  body: string
  steps: string
}

export const bonuses: Bonus[] = [
  {
    number: 1,
    title: 'OPHTHALMIC ANATOMY VISUAL REFERENCE™',
    subtitle: 'Essential Ocular Anatomy & Imaging Landmarks',
    body: 'Review ocular anatomy, retinal structures, optic nerve landmarks and important imaging relationships in one place. Use organized visual references and labeled diagrams whenever you need them. Keep essential anatomical information easier to find and review.',
    steps: 'Identify. Visualize. Reference.',
  },
  {
    number: 2,
    title: 'OPHTHALMIC DIFFERENTIAL PATTERN GUIDE™',
    subtitle: 'Side-by-Side Visual Comparisons',
    body: 'Compare ophthalmic findings, visual characteristics, anatomical locations and important pattern differences. Use structured comparisons to review similar-looking ophthalmic appearances. Stop searching for disconnected comparison images from scratch.',
    steps: 'Observe. Compare. Differentiate.',
  },
  {
    number: 3,
    title: 'OPHTHALMIC IMAGING ARTIFACTS & PITFALLS™',
    subtitle: 'Practical Image Quality & Artifact Review',
    body: 'Review image quality, segmentation, orientation, artifacts and common interpretation pitfalls. Use visual comparisons, quality checks and structured reference guides. Keep important imaging limitations together before interpreting each pattern.',
    steps: 'Check. Review. Interpret.',
  },
  {
    number: 4,
    title: 'OPHTHALMIC PATTERN RECOGNITION WORKBOOK™',
    subtitle: 'Practical Visual Pattern Review',
    body: 'Practice anatomy, imaging orientation, pattern comparison and structured visual observation. Use visual exercises, comparisons and complete educational explanations. Keep active ophthalmic image review organized in one practical resource.',
    steps: 'Observe. Practice. Review.',
  },
  {
    number: 5,
    title: 'OPHTHALMIC IMAGING QUICK REFERENCE™',
    subtitle: 'Essential Visual Reference Organization',
    body: 'Review essential OCT, fundus, optic nerve, visual field and corneal imaging concepts. Use ready-to-review checklists, maps and visual reference sheets. Keep important imaging information clearly organized and easy to review.',
    steps: 'Check. Compare. Reference.',
  },
]

export const differentiators = [
  {
    emoji: '👁️',
    title: 'Ready-to-use professional visual resources',
    body: 'Open the system and access organized references instead of searching for everything from scratch.',
  },
  {
    emoji: '🔬',
    title: 'Practical visual pattern review',
    body: 'Use atlases, comparisons, diagrams and reference guides to review ophthalmic imaging.',
  },
  {
    emoji: '🧩',
    title: '6 essential areas in one system',
    body: 'Keep OCT, retina, optic nerve, visual fields, cornea and multimodal imaging organized.',
  },
  {
    emoji: '🔄',
    title: 'Reusable visual resources',
    body: 'Return to the atlases, comparisons and reference guides whenever you need them.',
  },
  {
    emoji: '📂',
    title: 'Everything in one organized place',
    body: 'Stop relying on scattered images, references and disconnected study materials.',
  },
  {
    emoji: '⏱️',
    title: 'Less repetitive searching',
    body: 'Spend less time finding the same ophthalmic visual references every day.',
  },
]

export const offerChecklist = [
  '6 professional modules',
  '5 professional bonuses',
  'OCT pattern atlas',
  'Fundus & retinal atlas',
  'Optic nerve & RNFL visuals',
  'Visual field pattern atlas',
  'Corneal imaging references',
  'Multimodal integration tools',
]

export interface Testimonial {
  name: string
  role: string
  location: string
  quote: string
}

export const testimonials: Testimonial[] = [
  {
    name: 'Rachel Sandoval, 29',
    role: 'Ophthalmology resident · PGY-2',
    location: 'Columbus, United States',
    quote:
      'Before clinic I used to scroll through three textbooks and a folder of screenshots trying to remember what a decentred macular scan looks like. Now I open the OCT atlas, find the annotated comparison and move on. The artifacts and pitfalls bonus has saved me from calling thinning on a poor-quality scan more than once.',
  },
  {
    name: 'Daniel Okonkwo, 34',
    role: 'Optometrist · Primary eye care practice',
    location: 'Birmingham, United Kingdom',
    quote:
      'The optic nerve and RNFL section is the part I use weekly. Having disc appearances, rim patterns and RNFL comparisons side by side made my structure-function reasoning far more consistent. I also keep the quick reference open on a second screen during imaging days.',
  },
  {
    name: 'Priya Raghunathan, 26',
    role: 'Optometry student · Final year',
    location: 'Melbourne, Australia',
    quote:
      'I was studying fundus findings and OCT as two separate subjects and it never clicked. The multimodal integration atlas was the turning point — seeing the fundus image and the matching cross-section together is exactly how I needed it explained. My case presentations improved immediately.',
  },
  {
    name: 'Martin Beauchamp, 41',
    role: 'Ophthalmic technician · Imaging department',
    location: 'Ottawa, Canada',
    quote:
      'I capture OCT and fields all day and I wanted to understand what I was acquiring, not just how. The scan position and quality references gave me language for what I see on screen, and my acquisitions need far fewer repeats now.',
  },
  {
    name: 'Helen Carmichael, 52',
    role: 'Glaucoma clinic nurse specialist',
    location: 'Glasgow, United Kingdom',
    quote:
      'What I appreciate is how organized it is. Six areas, the same structure in each, everything annotated. I use the visual field pattern atlas and the differential guide to prepare before clinic lists, and the pattern recognition workbook with our newer staff during training sessions.',
  },
]

export interface Faq {
  q: string
  a: string
}

export const faqs: Faq[] = [
  {
    q: 'Is this a physical product?',
    a: 'No. OPHTHALMOLOGY VISUAL ATLAS™ is a 100% digital professional resource.',
  },
  {
    q: 'Who is this system for?',
    a: 'Ophthalmology learners, optometry learners and eye-care professionals looking for organized, ready-to-use visual resources for ophthalmic study.',
  },
  {
    q: 'Is this ophthalmology training or a certification?',
    a: 'No. It is a visual study and reference system, not a certification or replacement for required professional training.',
  },
  {
    q: 'Is this another ebook filled with theory?',
    a: 'No. The system focuses on visual atlases, annotated patterns, comparisons, imaging references and ready-to-review resources.',
  },
  {
    q: 'Do I have to create the resources myself?',
    a: 'No. The resources are already created and organized. Choose the appropriate atlas and use it according to your educational needs and professional responsibilities.',
  },
  {
    q: 'What areas are included?',
    a: 'OCT Patterns, Fundus & Retina, Optic Nerve & Glaucoma, Visual Fields, Corneal Imaging, and Ophthalmic Imaging Integration.',
  },
  {
    q: 'Can I use the resources in different study situations?',
    a: 'Yes. The visual resources can be used according to your learning needs, professional context and appropriate clinical references.',
  },
  {
    q: 'Are the resources ready to use?',
    a: 'Yes. They are designed for practical digital reference and visual ophthalmic study.',
  },
  {
    q: 'What additional resources are included?',
    a: 'Five bonuses covering visual anatomy, differential patterns, imaging artifacts, pattern recognition practice, and quick-reference imaging resources.',
  },
  {
    q: 'Does this replace clinical training or medical judgment?',
    a: 'No. OPHTHALMOLOGY VISUAL ATLAS™ does not replace clinical training, medical judgment, professional supervision, diagnostic evaluation or validated professional references.',
  },
  {
    q: 'How will I receive the product?',
    a: 'You’ll receive immediate digital access after your purchase.',
  },
]

export const purchaseNotifications = [
  { name: 'Emma Whitfield', city: 'Manchester', country: 'United Kingdom' },
  { name: 'Sarah Collins', city: 'Toronto', country: 'Canada' },
  { name: 'Michelle Brennan', city: 'Melbourne', country: 'Australia' },
  { name: 'Linda Carter', city: 'Columbus', country: 'United States' },
  { name: 'Joanne Mackay', city: 'Glasgow', country: 'United Kingdom' },
  { name: 'Rachel Dumont', city: 'Ottawa', country: 'Canada' },
  { name: 'Teresa Novak', city: 'San Antonio', country: 'United States' },
  { name: 'Katrina Boyle', city: 'Brisbane', country: 'Australia' },
  { name: 'Deborah Fields', city: 'Leeds', country: 'United Kingdom' },
  { name: 'Nicole Tremblay', city: 'Calgary', country: 'Canada' },
  { name: 'Angela Ruiz', city: 'Tampa', country: 'United States' },
  { name: 'Fiona Pearce', city: 'Perth', country: 'Australia' },
]
